import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "product/complement"

class service {

    selectList(params) {
        return http.list(path + "/selectList", params);
    }

    getComplementsByGroupProductId(groupProductId) {

        if (groupProductId > 0) {

            let params = new URLSearchParams()
            params.set("status", "1")
            params.set("groupProductId", groupProductId)

            return http.list(path + "/getAllByGroupProductId", params);

        }

    }

}

export default new service();

